'use client'

import React, { ReactNode } from 'react'
import { createAppKit } from '@reown/appkit/react'
import { wagmiAdapter, networks, customRpcUrls, projectId } from '../config'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WagmiProvider } from 'wagmi'

interface AppProviderProps {
  children: ReactNode
}

// Create a client for React Query
const queryClient = new QueryClient()

// Set up metadata
const metadata = {
  name: 'GAM',
  description: 'GAM Presale',
  url: process.env.NEXT_PUBLIC_BASE_URL || 'https://gam.io',
  icons: [`${process.env.NEXT_PUBLIC_BASE_URL || 'https://gam.io'}/GAM.png`],
};

// Create the AppKit instance outside the component and export it
export const appKitModal = createAppKit({
  adapters: [wagmiAdapter],
  networks: networks,
  projectId: projectId,
  metadata: metadata,
  features: {
    analytics: false,
    email: true,
  }
});

// AppProvider now primarily sets up Wagmi and React Query context
export const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <WagmiProvider config={wagmiAdapter.wagmiConfig}>
      <QueryClientProvider client={queryClient}>
        {children}
      </QueryClientProvider>
    </WagmiProvider>
  )
}
